import {
    SET_ADM_MEMBER_STATISTICS_LOADING,
    SET_ADM_MEMBER_STATISTICS_SUCCESS,
    SET_ADM_MEMBER_STATISTICS_ERROR,
    SET_ADM_MEMBER_STATISTICS_RESULT,
    GET_MEMBER_STATISTICS_INFO,
    GET_MEMBER_STATISTICS_INFO_SUCCESS,
    GET_MEMBER_ACTIVITY_INFO,
    GET_MEMBER_ACTIVITY_INFO_SUCCESS,
    GET_ADDED_CONTACTS_INFO,
    GET_ADDED_CONTACTS_INFO_SUCCESS,
    GET_DELETED_CONTACTS_INFO,
    GET_DELETED_CONTACTS_INFO_SUCCESS,
    SET_CONTACTS_LOG,
    GET_ADMIN_LIST,
    GET_ADMIN_LIST_SUCCESS,
    UPDATE_SALES_OWNER,
    UPDATE_SALES_OWNER_SUCCESS,
    GET_STARRED_ENTITIES_INFO,
    GET_STARRED_ENTITIES_INFO_SUCCESS,
    GET_HIDDEN_ENTITIES_INFO,
    GET_HIDDEN_ENTITIES_INFO_SUCCESS,
    SET_ENTITIES_STAR_HIDE_LOG
} from "./actionTypes";

const initialState = {
    error: "",
    loading: false,
    success: "",
    result: -1,
    totalPage: 1,
    noticeStr: "",
    totalPage: 0,
    toDate: null,
    fromDate: null,
    statUpdatedDate: null,
    statisticsList: [],
    activityList: [],
    activityNoticeStr: "",
    activityTotalPage: 1,
    contactsLog: [],
    contactsLogActive: [],
    contactsLogTotalPage: 1,
    entitiesStarHideLog: [],
    entitiesStarHideLogActive: [],
    entitiesStarHideLogTotalPage: 1,
    adminList: []
}

const AdmMemberStatistics = (state = initialState, action) => {
    switch (action.type) {
        case SET_ADM_MEMBER_STATISTICS_LOADING:
            state = {
                ...state,
                loading: action.payload,
            }
            break
        case SET_ADM_MEMBER_STATISTICS_SUCCESS:
            state = {
                ...state,
                success: action.payload,
            }
            break
        case SET_ADM_MEMBER_STATISTICS_ERROR:
            state = {
                ...state,
                error: action.payload,
            }
            break
        case SET_ADM_MEMBER_STATISTICS_RESULT:
            state = {
                ...state,
                result: action.payload,
            }
            break
        case GET_MEMBER_STATISTICS_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_MEMBER_STATISTICS_INFO_SUCCESS:
            state = {
                ...state,
                totalPage: action.payload.totalPage || 0,
                fromDate: action.payload.fromDate,
                toDate: action.payload.toDate,
                statUpdatedDate: action.payload.updatedDate,
                statisticsList: action.payload.result,
                noticeStr: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving statistics info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_MEMBER_ACTIVITY_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_MEMBER_ACTIVITY_INFO_SUCCESS:
            state = {
                ...state,
                activityList: action.payload.result,
                activityNoticeStr: action.payload.noticeStr,
                activityTotalPage: action.payload.totalPage || 1,
                error: action.payload.result === -1 ? "Error while retrieving activity info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_ADDED_CONTACTS_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_ADDED_CONTACTS_INFO_SUCCESS:
            state = {
                ...state,
                contactsLog: action.payload.result === -1 ? [] : action.payload.result,
                contactsLogActive: action.payload.result === -1 ? [] : action.payload.result.slice(0, Math.min(10, action.payload.result.length)),
                contactsLogTotalPage: action.payload.result === -1 ? 1 : Math.ceil(action.payload.result.length/10),
                error: action.payload.result === -1 ? "Error while retrieving logs info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_DELETED_CONTACTS_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_DELETED_CONTACTS_INFO_SUCCESS:
            state = {
                ...state,
                contactsLog: action.payload.result === -1 ? [] : action.payload.result,
                contactsLogActive: action.payload.result === -1 ? [] : action.payload.result.slice(0, Math.min(10, action.payload.result.length)),
                contactsLogTotalPage: action.payload.result === -1 ? 1 : Math.ceil(action.payload.result.length/10),
                error: action.payload.result === -1 ? "Error while retrieving logs info: contact system administrator!" : "",
                loading: false,
            }
            break
        case SET_CONTACTS_LOG:
            state = {
                ...state,
                contactsLog: action.payload.contactsLog,
                contactsLogActive: action.payload.contactsLogActive,
                contactsLogTotalPage: action.payload.contactsLogTotalPage,
            }
            break
        case GET_STARRED_ENTITIES_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_STARRED_ENTITIES_INFO_SUCCESS:
            state = {
                ...state,
                entitiesStarHideLog: action.payload.result === -1 ? [] : action.payload.result,
                entitiesStarHideLogActive: action.payload.result === -1 ? [] : action.payload.result.slice(0, Math.min(10, action.payload.result.length)),
                entitiesStarHideLogTotalPage: action.payload.result === -1 ? 1 : Math.ceil(action.payload.result.length/10),
                error: action.payload.result === -1 ? "Error while retrieving logs info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_HIDDEN_ENTITIES_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_HIDDEN_ENTITIES_INFO_SUCCESS:
            state = {
                ...state,
                entitiesStarHideLog: action.payload.result === -1 ? [] : action.payload.result,
                entitiesStarHideLogActive: action.payload.result === -1 ? [] : action.payload.result.slice(0, Math.min(10, action.payload.result.length)),
                entitiesStarHideLogTotalPage: action.payload.result === -1 ? 1 : Math.ceil(action.payload.result.length/10),
                error: action.payload.result === -1 ? "Error while retrieving logs info: contact system administrator!" : "",
                loading: false,
            }
            break
        case SET_ENTITIES_STAR_HIDE_LOG:
            state = {
                ...state,
                entitiesStarHideLog: action.payload.entitiesStarHideLog,
                entitiesStarHideLogActive: action.payload.entitiesStarHideLogActive,
                entitiesStarHideLogTotalPage: action.payload.entitiesStarHideLogTotalPage,
            }
            break
        case GET_ADMIN_LIST:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_ADMIN_LIST_SUCCESS:
            state = {
                ...state,
                adminList: action.payload.result === -1 ? [] : action.payload.result,
                error: action.payload.result === -1 ? "Error while retrieving admin list: contact system administrator!" : "",
                loading: false,
            }
            break
        case UPDATE_SALES_OWNER:
            state = {
                ...state,
                loading: true,
            }
            break
        case UPDATE_SALES_OWNER_SUCCESS:
            state = {
                ...state,
                success: action.payload.result === -1 ? "" : action.payload.result,
                error: action.payload.result === -1 ? "Error while updating sales owner: contact system administrator!" : "",
                loading: false,
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}

export default AdmMemberStatistics;
